import { Collapse, message } from 'antd';
import React from 'react';
import { redirect, useFetcher, useRouteLoaderData } from 'react-router-dom';
import { sendProoftoClient, sendVendorArtworktoStudio } from '../../api/order/order-manager.js';
import FileTransfer from '../../components/inputs/FileTransfer.jsx';
import { generateRouteUrl } from '../../library/constants/routes.js';
const { Panel } = Collapse

const SendProofToCustomer = () => {
    const { orderDetails, orderFiles } = useRouteLoaderData('OrderManagerFileTransfer');
    const fetcher = useFetcher()
    const existingFiles = orderFiles?.vendor_proof ?? []

    return (
        <Collapse defaultActiveKey={['1']} expandIconPosition="end">
            <Panel header='Send Proof to Customer' key="1">
                <FileTransfer
                    existingFiles={existingFiles}
                    orderDetails={orderDetails}
                    orderManagerStudioActionText="Sent to Customer"
                    loading={fetcher.state !== 'idle'}
                    onSendToStudio={existingFiles.length ? (data) => fetcher.submit({
                        ...data,
                        action: 'sendToStudio'
                    }, {
                        method: 'post',
                        encType: 'application/json'
                    }) : undefined}
                    onOrderManagerStudio={existingFiles.length ? (data) => fetcher.submit({
                        ...data,
                        action: 'sendToCustomer'
                    }, {
                        method: 'post',
                        encType: 'application/json'
                    }) : undefined}
                    onManualUpload={existingFiles.length === 0 ? (data) => fetcher.submit({
                        ...data,
                        action: 'sendToCustomer'
                    }, {
                        method: 'post',
                        encType: 'application/json'
                    }) : undefined}
                    manualUploadActionText="Upload and send to Customer"
                    onSendToCustomer={existingFiles.length ? (data) => {
                        fetcher.submit({
                            ...data,
                            action: 'sendToCustomer'
                        }, {
                            method: 'post',
                            encType: 'application/json'
                        })
                    } : undefined}
                />
            </Panel>
        </Collapse>
    )
}
SendProofToCustomer.Actions = {
    sendToStudio: async ({ params, data }) => {
        try {
            const { existingFiles = [], comment } = data
            const { message: msg } = await sendVendorArtworktoStudio(params.itemId, { images: existingFiles, comment, image_ids: [] })
            message.success(msg)
            return redirect(generateRouteUrl('OrderManagerDetailsPage', { itemId: params.itemId }))
        }
        catch (error) {
            message.error(error.message)
            return false
        }
    },
    sendToCustomer: async ({ params, data }) => {
        try {
            const { existingFiles = [], newFiles = [], comment } = data
            const payload = {
                images: existingFiles,
                image_ids: newFiles,
                comment
            }
            const { message: msg } = await sendProoftoClient(params.itemId, payload)
            message.success(msg)
            return redirect(generateRouteUrl('OrderManagerDetailsPage', { itemId: params.itemId }))
        }
        catch (error) {
            message.error(error.message)
            return false
        }
    },
}
export default SendProofToCustomer